import { Feature, LineString, Position } from "geojson";

/**
 * Return the start and end coordinates of a LineString feature.
 *
 * Will raise an error if the LineString is empty.
 *
 * @param feature The LineString feature
 */
export function getLineStringEndpoints(feature: Feature<LineString>): [Position, Position] {
  const coords = feature.geometry.coordinates;
  return [coords[0], coords[coords.length - 1]];
}
